module.exports = function() {
  return new Worker(__webpack_public_path__ + "38762ef9b2abd4a0fc0f.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/build/pdf.worker.js
 ** module id = 1682
 ** module chunks = 0
 **/